.applyButtonContainer {
  margin-top: 8px;
}

.downloadButtonContainer {
  margin-top: 8px;
  margin-left: 8px;
}

.interval div:global(.ant-form-item-label.ant-form-item-label-wrap) {
  text-align: left;
}
